/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-20-05 06:08:02
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { processRes } from 'src/helpers/actions-helper';
import { I18n } from '@shopify/react-i18n';

import apiService from 'src/services/api-service';
import {
  GET_AVAILABLE_SORT_TYPES_REQUEST,
  GET_AVAILABLE_SORT_TYPES_SUCCESS,
  GET_AVAILABLE_SORT_TYPES_FAILURE,
  GET_CUSTOM_SORTING_REQUEST,
  GET_CUSTOM_SORTING_SUCCESS,
  GET_CUSTOM_SORTING_FAILURE,
  UPDATE_CUSTOM_SORTING_REQUEST,
  UPDATE_CUSTOM_SORTING_SUCCESS,
  UPDATE_CUSTOM_SORTING_FAILURE
} from 'stores/flow-type/custom-sorting.type';
import { trackFSEvent } from 'src/integrations/fullStory';

/**
 * Get available sort types
 * @return {object} The RSAA object for API middleware
 */
export const getAvailableSortTypes = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.custom-sorting.get-available-sort-types', {}, [
    GET_AVAILABLE_SORT_TYPES_REQUEST,
    {
      type: GET_AVAILABLE_SORT_TYPES_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data, i18n };
      }
    },
    {
      type: GET_AVAILABLE_SORT_TYPES_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.CustomSorting.Actions.getAvailableSortTypes_Failure'),
          i18n
        )
    }
  ]);
};

/**
 * get custom sorting
 * @return {object} The RSAA object for API middleware
 */
export const getCustomSorting = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.custom-sorting.get-sort-by-options', {}, [
    GET_CUSTOM_SORTING_REQUEST,
    {
      type: GET_CUSTOM_SORTING_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: GET_CUSTOM_SORTING_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.CustomSorting.Actions.getAvailableSortTypes_Failure'),
          i18n
        )
    }
  ]);
};

/**
 * Update custom sorting
 * @return {object} The RSAA object for API middleware
 */
export const updateCustomSorting = (body, i18n) => {
  return apiService.sendRequest('admin-v3.custom-sorting.update-sort-by-options', { body }, [
    UPDATE_CUSTOM_SORTING_REQUEST,
    {
      type: UPDATE_CUSTOM_SORTING_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        // Track Full Story event
        trackFSEvent('Edit Sort by options', {
          feature: 'Sort by Options',
          enableSortingOption: body?.defaultSorting?.status
        });
        return { data };
      }
    },
    {
      type: UPDATE_CUSTOM_SORTING_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.CustomSorting.Actions.updateCustomSorting_Failure'),
          i18n
        )
    }
  ]);
};
